module.exports = __webpack_public_path__ + "img/gallery-4.d19b87a5.jpg";